<template>
  <div>
    <div v-if="loading">
      `
      <div class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>
    </div>
    <div v-if="!loading" class="app-container">
      <div class="banner m-prof-banner">
        <img v-if="viewUser.bg_img ? viewUser.bg_img[0].url : viewUser.background_image" :src="viewUser.bg_img ? viewUser.bg_img[0].url : viewUser.background_image" alt="bg-image" />
        <img v-else src="https://mycircle-prod.s3.amazonaws.com/default-profile-bg-img1698993539.jpg" alt="background" class="default-profile-bg-img default-profile-bg-img-mobile" />
      </div>
      <div class="profile-subnav">
        <div class="dovemed-wrapper w-100">
          <!-- commented left content -->
          <!-- RIGHT CONTENT -->

          <div class="nav-sec p-4">
            <div class="mt-1 profile-tabs sort-dropdown">
              <!-- Psoriasis/profile/view/hcp/251/updates -->
              <div
                id="updates"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                    ? { color: getPrimaryColor(), background: getPrimary50Color() }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                Updates
              </div>
              <div
                id="about"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                    ? { color: getPrimaryColor(), background: getPrimary50Color() }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                About
              </div>
              <li
                v-if="isDirectory && viewUser.role !== 'nfp_administrator'"
                :style="$route.path.includes('receivedreviews') ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
                id="receivedreviews"
                :class="$route.path.includes('receivedreviews') ? 'active-tabs' : 'tabs'"
                @click="handletab($event)"
              >
                Received Reviews
              </li>
              <!-- <div
                v-if="!isDirectory"
                id="dovedaily"
                :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/dovedaily` ? 'active-tabs cp' : 'tabs cp'"
                :style="
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                    ? { color: getPrimaryColor(), background: getPrimary50Color() }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                DoveDaily
              </div> -->
              <div
                v-if="!isDirectory"
                id="circles"
                :class="
                  this.$route.path.includes('ViewAllCircle') ||
                  this.$route.path.includes('self') ||
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/hospitals` ||
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/clinics` ||
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/nfp` ||
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/hcp` ||
                  this.$route.path.includes('providers')
                    ? 'active-tabs'
                    : 'tabs'
                "
                :style="
                  this.$route.path.includes('ViewAllCircle') ||
                  this.$route.path.includes('self') ||
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/hospitals` ||
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/clinics` ||
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/nfp` ||
                  this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/hcp` ||
                  this.$route.path.includes('providers')
                    ? { color: getPrimaryColor(), background: getPrimary50Color() }
                    : { color: '#0F1734' }
                "
                @click="handletab($event)"
              >
                Circles
              </div>
              <a-dropdown :trigger="['click']" v-if="!isDirectory" v-model="displayDots2W" :getPopupContainer="trigger => trigger.parentNode">
                <div
                  :style="
                    this.$route.path.includes('muteduser') ||
                    this.$route.path.includes('qa') ||
                    this.$route.path.includes('polls') ||
                    this.$route.path.includes('saved') ||
                    this.$route.path.includes('profilerev') ||
                    this.$route.path.includes('medrev') ||
                    this.$route.path.includes('receivedreviews') ||
                    this.$route.path.includes('profilercmnd') ||
                    this.$route.path.includes('treatmentrcmnd')
                      ? { color: getPrimaryColor(), background: getPrimary50Color(), 'z-index': 100 }
                      : { color: '#0F1734', 'z-index': 100 }
                  "
                  id="reviews"
                  :class="
                    this.$route.path.includes('muteduser') ||
                    this.$route.path.includes('qa') ||
                    this.$route.path.includes('polls') ||
                    this.$route.path.includes('saved') ||
                    this.$route.path.includes('profilerev') ||
                    this.$route.path.includes('medrev') ||
                    this.$route.path.includes('profilercmnd') ||
                    this.$route.path.includes('receivedreviews') ||
                    this.$route.path.includes('treatmentrcmnd')
                      ? 'active-tabs'
                      : 'tabs'
                  "
                >
                  <div
                    :style="
                      this.$route.path.includes('muteduser') ||
                      this.$route.path.includes('qa') ||
                      this.$route.path.includes('polls') ||
                      this.$route.path.includes('saved') ||
                      this.$route.path.includes('profilerev') ||
                      this.$route.path.includes('medrev') ||
                      this.$route.path.includes('receivedreviews') ||
                      this.$route.path.includes('profilercmnd') ||
                      this.$route.path.includes('treatmentrcmnd')
                        ? { color: getPrimaryColor() }
                        : ''
                    "
                    class="tabe"
                  >
                    {{ "Reviews & More" }}
                    <!-- {{ selectedTab }} -->
                    <font-awesome-icon size="1x" :icon="displayDots2W ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
                  </div>
                </div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item
                      id="qa"
                      @click="
                        () => {
                          selectedTab = 'Q&A'
                          $router.push({ path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/qa` })
                        }
                      "
                      class="card-item"
                    >
                      Q&A
                    </a-menu-item>
                    <a-menu-item
                      id="polls"
                      @click="
                        () => {
                          selectedTab = 'Polls'
                          $router.push({ path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/polls` })
                        }
                      "
                      class="card-item"
                    >
                      Polls
                    </a-menu-item>
                    <a-menu-item
                      id="saved"
                      @click="
                        () => {
                          selectedTab = 'Saved'
                          $router.push({ path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/saved` })
                        }
                      "
                      class="card-item"
                    >
                      Saved
                    </a-menu-item>
                    <a-menu-item
                      id="medrev"
                      @click="
                        () => {
                          selectedTab = 'Medication Reviews'
                          $router.push({ path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/medrev` })
                        }
                      "
                      class="card-item"
                    >
                      Medication Reviews
                    </a-menu-item>
                    <a-menu-item
                      id="treatmentrcmnd"
                      @click="
                        () => {
                          selectedTab = 'Treatment Recommendations'
                          $router.push({ path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/treatmentrcmnd` })
                        }
                      "
                      class="card-item"
                    >
                      Treatment Recommendations
                    </a-menu-item>
                    <a-menu-item
                      id="receivedreviews"
                      @click="
                        () => {
                          selectedTab = 'Received Reviews'
                          $router.push({ path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/receivedreviews/all` })
                        }
                      "
                      class="card-item"
                    >
                      Received Reviews
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- mobile view -->
      <div class="circle-card m-prof position-relative">
        <div class="circle-card-content text-center position-relative">
          <div>
            <!-- <a-avatar
              :size="100"
              icon="user"
              :src="viewUser.url || viewUser.picture || defaultImage"
              alt=""
              :style="{ background: 'aliceblue' }"
            /> -->
            <button class="threedot-menu mob" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="() => $refs.drawerShareRef.show()">
              <font-awesome-icon
                size="1x"
                :style="{
                  color: '#94A3B8',
                }"
                :icon="['fas', 'ellipsis-v']"
              />
            </button>
            <a-avatar
              :style="{
                color: ' #ffffff !important',
                'background-color': viewUser.url ? viewUser.url : '' || viewUser.picture ? viewUser.picture : '' ? '' : '#C997C5',
              }"
              :size="160"
              :src="viewUser.url || viewUser.picture"
              class="text-capitalize"
            >
              {{ viewUser.display_name ? viewUser.display_name[0] : viewUser.role === "hcp" ? viewUser.hcp_info.full_name[0] : viewUser.doctor_info.full_name[0] }}
            </a-avatar>
            <div class="d-flex flex-row" :style="{ 'margin-top': '26px' }">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ 'margin-right': '8px' }">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.6458 0.648784C10.9757 0.238571 11.4736 0 11.9998 0C12.526 0 13.0239 0.238571 13.3537 0.648784L14.9657 2.65518C15.3367 3.11777 15.9179 3.35907 16.5072 3.29518L19.0659 3.01678C19.5905 2.95846 20.1132 3.14192 20.4865 3.51539C20.8598 3.88886 21.0431 4.41184 20.9848 4.93677L20.7066 7.49676C20.6427 8.08643 20.8839 8.66795 21.3462 9.03916L23.3516 10.652C23.7616 10.982 24 11.4801 24 12.0066C24 12.5331 23.7616 13.0312 23.3516 13.3613L21.3398 14.9666C20.8776 15.3384 20.6366 15.9201 20.7002 16.5101L20.9784 19.0701C21.0371 19.5951 20.8539 20.1183 20.4805 20.4919C20.1072 20.8655 19.5842 21.0488 19.0595 20.9901L16.5008 20.7117C15.9115 20.6476 15.3301 20.8889 14.9593 21.3517L13.3537 23.3506C13.0241 23.7612 12.5261 24 11.9998 24C11.4734 24 10.9755 23.7612 10.6458 23.3506L9.03497 21.3453C8.66351 20.8826 8.08199 20.6414 7.49234 20.7053L4.93371 20.9837C4.40886 21.0428 3.88565 20.8596 3.51218 20.4859C3.1387 20.1123 2.95562 19.5888 3.01474 19.0637L3.29299 16.5037C3.35682 15.9137 3.11569 15.3319 2.65333 14.9602L0.649074 13.3485C0.238717 13.0187 0 12.5205 0 11.9938C0 11.4672 0.238717 10.969 0.649074 10.6392L2.65333 9.02636C3.11584 8.65528 3.35705 8.07366 3.29299 7.48396L3.01474 4.92397C2.95604 4.39894 3.13926 3.8757 3.51263 3.50214C3.886 3.12857 4.40896 2.94524 4.93371 3.00398L7.49234 3.28238C8.08196 3.34604 8.66338 3.10482 9.03497 2.64238L10.6458 0.648784Z"
                  fill="#00C853"
                />
                <path
                  d="M16.5 9L12.0214 15.3893C11.8746 15.5985 11.6502 15.7293 11.4063 15.7477C11.1624 15.7662 10.923 15.6706 10.7501 15.4856L8.0625 12.6112"
                  stroke="white"
                  stroke-width="2.08333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p :style="{ 'font-weight': '700', 'font-size': '16px', 'line-height': '24px', color: '#00C853' }">Verified and Claimed</p>
            </div>
          </div>
        </div>
        <div class="doc-info">
          <span class="m-0 mt-md-2 doc-name" v-if="viewUser && viewUser.role === 'hcp'">
            {{
              viewUser.display_name
                ? viewUser.display_name + "" + (viewUser.title != null ? "," + viewUser.title : "")
                : viewUser.hcp_info.full_name + "" + (viewUser.title != null ? "," + viewUser.title : "")
            }}
          </span>
          <span class="m-0 mt-md-2 doc-name" v-else>
            <!-- {{
              viewUser.display_name
                ? viewUser.display_name + "" + (viewUser.title != null ? "," + viewUser.title : "")
                : viewUser.doctor_info.full_name + "" + (viewUser.title != null ? "," + viewUser.title : "")
            }} -->
            {{ viewUser.display_name || viewUser.doctor_info.full_name || "" }}
          </span>
          <div class="tag-cont">
            <div class="physician-tag">
              <font-awesome-icon v-if="viewUser.role === 'hcp'" class="tag-icon-oran" :icon="['far', 'user-nurse']" :style="{ fill: '#F5A623' }" />
              <font-awesome-icon v-if="viewUser.role === 'nfp_administrator'" class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" :style="{ fill: '#F5A623' }" />
              <svg v-if="viewUser.role === 'doctor'" class="tag-icon-oran" :style="{ fill: '#F5A623' }" width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.0835 3.11198C3.0835 1.51693 4.38232 0.195312 6.00016 0.195312C7.59521 0.195312 8.91683 1.51693 8.91683 3.11198C8.91683 4.72982 7.59521 6.02865 6.00016 6.02865C4.38232 6.02865 3.0835 4.72982 3.0835 3.11198ZM7.82308 3.11198C7.82308 2.10938 7.00277 1.28906 6.00016 1.28906C4.97477 1.28906 4.17725 2.10938 4.17725 3.11198C4.17725 4.13737 4.97477 4.9349 6.00016 4.9349C7.00277 4.9349 7.82308 4.13737 7.82308 3.11198ZM4.54183 9.37826C5.06592 9.53776 5.45329 10.0163 5.45329 10.5859C5.45329 11.2923 4.86084 11.862 4.17725 11.862C3.47087 11.862 2.9012 11.2923 2.9012 10.5859C2.9012 10.0163 3.26579 9.53776 3.81266 9.37826V8.44401C2.7417 8.87695 1.98975 9.92513 1.98975 11.1328V11.3151C1.98975 11.6341 1.7391 11.862 1.44287 11.862C1.12386 11.862 0.895996 11.6341 0.895996 11.3151V11.1328C0.895996 8.92253 2.67334 7.1224 4.90641 7.1224H7.09391C9.3042 7.1224 11.1043 8.92253 11.1043 11.1328V11.3151C11.1043 11.6341 10.8537 11.862 10.5575 11.862C10.2384 11.862 10.0106 11.6341 10.0106 11.3151V11.1328C10.0106 9.92513 9.23584 8.87695 8.18766 8.44401V9.37826C8.71175 9.53776 9.09912 10.0163 9.09912 10.5859V11.3151C9.09912 11.5202 8.91683 11.6797 8.73454 11.6797C8.52946 11.6797 8.36995 11.5202 8.36995 11.3151V10.5859C8.36995 10.2897 8.1193 10.0391 7.82308 10.0391C7.50407 10.0391 7.2762 10.2897 7.2762 10.5859V11.3151C7.2762 11.5202 7.09391 11.6797 6.91162 11.6797C6.70654 11.6797 6.54704 11.5202 6.54704 11.3151V10.5859C6.54704 10.0163 6.91162 9.53776 7.4585 9.37826V8.23893C7.32178 8.23893 7.20784 8.21615 7.09391 8.21615H4.90641C4.76969 8.21615 4.65576 8.23893 4.54183 8.23893V9.37826ZM4.17725 11.1328C4.47347 11.1328 4.72412 10.9049 4.72412 10.5859C4.72412 10.2897 4.47347 10.0391 4.17725 10.0391C3.85824 10.0391 3.63037 10.2897 3.63037 10.5859C3.63037 10.9049 3.85824 11.1328 4.17725 11.1328Z"
                />
              </svg>
              <svg v-if="viewUser.role === 'hospital_administrator'" class="tag-icon-oran" :style="{ fill: '#F5A623' }" width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.53906 9.67448H3.6276C3.4681 9.67448 3.35417 9.8112 3.35417 9.94792V10.8594C3.35417 11.0189 3.4681 11.1328 3.6276 11.1328H4.53906C4.67578 11.1328 4.8125 11.0189 4.8125 10.8594V9.94792C4.8125 9.8112 4.67578 9.67448 4.53906 9.67448ZM7.45573 9.67448H6.54427C6.38477 9.67448 6.27083 9.8112 6.27083 9.94792V10.8594C6.27083 11.0189 6.38477 11.1328 6.54427 11.1328H7.45573C7.59245 11.1328 7.72917 11.0189 7.72917 10.8594V9.94792C7.72917 9.8112 7.59245 9.67448 7.45573 9.67448ZM4.53906 7.48698H3.6276C3.4681 7.48698 3.35417 7.6237 3.35417 7.76042V8.67188C3.35417 8.83138 3.4681 8.94531 3.6276 8.94531H4.53906C4.67578 8.94531 4.8125 8.83138 4.8125 8.67188V7.76042C4.8125 7.6237 4.67578 7.48698 4.53906 7.48698ZM7.45573 7.48698H6.54427C6.38477 7.48698 6.27083 7.6237 6.27083 7.76042V8.67188C6.27083 8.83138 6.38477 8.94531 6.54427 8.94531H7.45573C7.59245 8.94531 7.72917 8.83138 7.72917 8.67188V7.76042C7.72917 7.6237 7.59245 7.48698 7.45573 7.48698ZM10.3724 7.48698H9.46094C9.30143 7.48698 9.1875 7.6237 9.1875 7.76042V8.67188C9.1875 8.83138 9.30143 8.94531 9.46094 8.94531H10.3724C10.5091 8.94531 10.6458 8.83138 10.6458 8.67188V7.76042C10.6458 7.6237 10.5091 7.48698 10.3724 7.48698ZM12.1042 2.38281H11.375V1.67643C11.375 0.85612 10.7142 0.195312 9.91667 0.195312H4.06055C3.26302 0.195312 2.60221 0.85612 2.60221 1.67643V2.38281H1.89583C1.07552 2.38281 0.4375 3.04362 0.4375 3.84115V11.3151C0.4375 11.6341 0.665365 11.862 0.984375 11.862C1.2806 11.862 1.53125 11.6341 1.53125 11.3151V3.84115C1.53125 3.65885 1.69076 3.47656 1.89583 3.47656H3.69596V1.67643C3.69596 1.47135 3.85547 1.28906 4.06055 1.28906H9.91667C10.1217 1.28906 10.2812 1.47135 10.2812 1.67643V3.47656H12.1042C12.2865 3.47656 12.4688 3.65885 12.4688 3.84115V11.3151C12.4688 11.6341 12.6966 11.862 13.0156 11.862C13.3118 11.862 13.5625 11.6341 13.5625 11.3151V3.84115C13.5625 3.04362 12.9017 2.38281 12.1042 2.38281ZM10.3724 9.67448H9.46094C9.30143 9.67448 9.1875 9.8112 9.1875 9.94792V10.8594C9.1875 11.0189 9.30143 11.1328 9.46094 11.1328H10.3724C10.5091 11.1328 10.6458 11.0189 10.6458 10.8594V9.94792C10.6458 9.8112 10.5091 9.67448 10.3724 9.67448ZM8.57227 3.47656H7.72917V2.63346C7.72917 2.49674 7.61523 2.38281 7.47852 2.38281H6.4987C6.36198 2.38281 6.27083 2.49674 6.27083 2.63346V3.47656H5.40495C5.26823 3.47656 5.17708 3.5905 5.17708 3.72721V4.70703C5.17708 4.84375 5.26823 4.9349 5.40495 4.9349H6.27083V5.80078C6.27083 5.9375 6.36198 6.02865 6.4987 6.02865H7.47852C7.61523 6.02865 7.72917 5.9375 7.72917 5.80078V4.9349H8.57227C8.70898 4.9349 8.82292 4.84375 8.82292 4.70703V3.72721C8.82292 3.5905 8.70898 3.47656 8.57227 3.47656Z"
                />
              </svg>
              <svg v-if="viewUser.role === 'clinic_administrator'" class="tag-icon-oran" :style="{ fill: '#F5A623' }" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.45833 4.2513V3.45378C6.45833 3.36263 6.36719 3.27148 6.25325 3.27148H5.56966V2.58789C5.56966 2.47396 5.47852 2.38281 5.38737 2.38281H4.58984C4.4987 2.38281 4.40755 2.47396 4.40755 2.58789V3.27148H3.72396C3.61003 3.27148 3.54167 3.36263 3.54167 3.45378V4.2513C3.54167 4.34245 3.61003 4.43359 3.72396 4.43359H4.40755V5.11719C4.40755 5.23112 4.4987 5.29948 4.58984 5.29948H5.38737C5.47852 5.29948 5.56966 5.23112 5.56966 5.11719V4.43359H6.25325C6.36719 4.43359 6.45833 4.34245 6.45833 4.2513ZM3.9974 6.75781H3.08594C2.92643 6.75781 2.8125 6.89453 2.8125 7.03125V7.94271C2.8125 8.10221 2.92643 8.21615 3.08594 8.21615H3.9974C4.13411 8.21615 4.27083 8.10221 4.27083 7.94271V7.03125C4.27083 6.89453 4.13411 6.75781 3.9974 6.75781ZM3.9974 8.94531H3.08594C2.92643 8.94531 2.8125 9.08203 2.8125 9.21875V10.1302C2.8125 10.2897 2.92643 10.4036 3.08594 10.4036H3.9974C4.13411 10.4036 4.27083 10.2897 4.27083 10.1302V9.21875C4.27083 9.08203 4.13411 8.94531 3.9974 8.94531ZM7.91667 0.195312H2.08333C1.26302 0.195312 0.625 0.85612 0.625 1.65365V11.3151C0.625 11.6341 0.852865 11.862 1.17188 11.862C1.4681 11.862 1.71875 11.6341 1.71875 11.3151V1.65365C1.71875 1.47135 1.87826 1.28906 2.08333 1.28906H7.91667C8.09896 1.28906 8.28125 1.47135 8.28125 1.65365V11.3151C8.28125 11.6341 8.50911 11.862 8.82812 11.862C9.12435 11.862 9.375 11.6341 9.375 11.3151V1.65365C9.375 0.85612 8.71419 0.195312 7.91667 0.195312ZM6.91406 6.75781H6.0026C5.8431 6.75781 5.72917 6.89453 5.72917 7.03125V7.94271C5.72917 8.10221 5.8431 8.21615 6.0026 8.21615H6.91406C7.05078 8.21615 7.1875 8.10221 7.1875 7.94271V7.03125C7.1875 6.89453 7.05078 6.75781 6.91406 6.75781ZM6.91406 8.94531H6.0026C5.8431 8.94531 5.72917 9.08203 5.72917 9.21875V10.1302C5.72917 10.2897 5.8431 10.4036 6.0026 10.4036H6.91406C7.05078 10.4036 7.1875 10.2897 7.1875 10.1302V9.21875C7.1875 9.08203 7.05078 8.94531 6.91406 8.94531Z"
                />
              </svg>
              <div>
                {{
                  viewUser.role === "doctor"
                    ? "Physician"
                    : viewUser.role === "hospital_administrator"
                    ? "Hospital"
                    : viewUser.role === "clinic_administrator"
                    ? "clinic"
                    : viewUser.role === "nfp_administrator"
                    ? "Non-For-Profit"
                    : viewUser.role === "hcp"
                    ? "Advanced Medical Professional"
                    : viewUser.role
                }}
              </div>
            </div>
            <div class="tags" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="viewUser.speciality">
              {{ viewUser.speciality }}
            </div>
            <div class="tags" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="tag && viewUser.role != 'doctor' && viewUser.role != 'hcp'">
              {{ tag }}
            </div>
          </div>
          <p
            :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', 'padding-bottom': '14.5px' }"
            v-if="viewUser.location && viewUser.location[0].city"
            class="m-0 doc-loc text-truncate"
          >
            <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
            {{ viewUser.location[0].street ? viewUser.location[0].street + "," : "" }}
            {{ viewUser.location[0].city }},
            {{ viewUser.location[0].state }}
          </p>
          <p
            :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', 'padding-bottom': '14.5px' }"
            v-else-if="userValues.location && userValues.location[0].city"
            class="m-0 doc-loc text-truncate"
          >
            <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
            {{ userValues.location[0].street ? userValues.location[0].street + "," : "" }}
            {{ userValues.location[0].city }},
            {{ userValues.location[0].state }}
          </p>
          <p :style="{ 'margin-bottom': '0px' }" class="d-flex" v-if="viewUser.role !== 'nfp_administrator'">
            <ReviewStar :rating="totalRating.toFixed(2)" :key="totalRating" :width="30" :height="30" />
            <!-- <Reviewstarforcircle :rating="totalRating.toFixed(2)" :key="totalRating" /> -->
            <!-- <Reviewstarforcircle :rating="userValues.rating ? userValues.rating : viewUser.rating ? viewUser.rating : 0" /> -->
          </p>

          <p :style="{ 'line-height': '21px', color: '#0F1734', 'margin-top': '6px !important' }" :key="totalRevCount" v-if="viewUser.role !== 'nfp_administrator'" class="fw400 font14 mb-0">
            {{ totalRating.toFixed(2) }}
            <!-- {{ userValues.rating ? userValues.rating.toFixed(2) : viewUser.rating ? viewUser.rating.toFixed(2) : "0" }} -->
            stars -
            {{ totalRevCount }}
            <!-- {{ userValues.no_of_reviews ? userValues.no_of_reviews : viewUser.review_count ? viewUser.review_count : "0" }} -->
            reviews
          </p>

          <div class="font14 gray500 mt-3" v-if="viewUser.joined_date">Member since: {{ formatDate(viewUser.joined_date) }}</div>

          <div class="stat-cont">
            <div class="statistics">
              <div class="circle-mem">
                <span class="num">{{ userValues.no_of_recommendations ? userValues.no_of_recommendations : viewUser.recommendation_count ? viewUser.recommendation_count : 0 }}</span>
                <span class="num-text">Recommendations</span>
              </div>
              <template v-if="viewUser.role !== 'nfp_administrator'">
                <div class="vertical-seperator"></div>
                <div class="circle-on">
                  <span class="num">{{ totalRevCount }}</span>
                  <!-- <span class="num">{{ userValues.no_of_reviews ? userValues.no_of_reviews : viewUser.review_count ? viewUser.review_count : 0 }}</span> -->
                  <span class="num-text">Reviews</span>
                </div>
              </template>
            </div>

            <div class="statistics" v-if="!isDirectory">
              <div class="circle-mem">
                <span class="num">{{ userValues.no_of_members ? userValues.no_of_members : viewUser.no_of_members ? viewUser.no_of_members : 0 }}</span>
                <span class="num-text">Circle Members</span>
              </div>
              <div class="vertical-seperator"></div>
              <div class="circle-on">
                <span class="num"> {{ userValues.no_of_circle_on ? userValues.no_of_circle_on : viewUser.no_of_circle_on ? viewUser.no_of_circle_on : 0 }}</span>
                <span class="num-text">Circle On</span>
              </div>
            </div>
          </div>
        </div>
        <div class="circle-card-footer">
          <div class="w-100 text-center d-flex justify-content-center">
            <div class="btns" :style="{ marginTop: '40px' }">
              <div class="d-flex flex-row">
                <button
                  v-if="!isDirectory"
                  class="font-white primary-button review-btns"
                  :style="{ background: getPrimaryColor(), cursor: 'pointer' }"
                  @click="() => $refs.MessageUserModal.ShowModal(viewUser)"
                >
                  Message
                </button>
                <!-- <div
                  v-if="
                    (viewUser.role === 'nfp_administrator' && (authUser.user.role === 'patient' || authUser.user.role === 'caregiver' || authUser.user.role === 'advocate')) ||
                    ((viewUser.role === 'doctor' || viewUser.role === 'hcp') &&
                      (authUser.user.role === 'hcp' ||
                        authUser.user.role === 'doctor' ||
                        authUser.user.role === 'hospital_administrator' ||
                        authUser.user.role === 'clinic_administrator' ||
                        authUser.user.role === 'nfp_administrator')) ||
                    ((viewUser.role === 'hcp' ||
                      authUser.user.role === 'doctor' ||
                      viewUser.role === 'hospital_administrator' ||
                      viewUser.role === 'clinic_administrator' ||
                      viewUser.role === 'nfp_administrator') &&
                      (authUser.user.role === 'doctor' || authUser.user.role === 'hcp'))
                  "
                > -->
                <div v-if="!canReview(viewUser.role)">
                  <button
                    class="font-white primary-button review-btns"
                    :style="{
                      background: this.DocRecommend ? getSecondaryColor() : getPrimaryColor(),
                      cursor: this.DocRecommend ? 'default' : 'pointer',
                      'margin-left': viewUser.isDirectory ? '0px' : '16px',
                      width: viewUser.isDirectory ? '335px' : '159.5px',
                      display: 'flex',
                      'flex-direction': 'row',
                    }"
                    :disabled="this.DocRecommend"
                    @click="handleRecomendPhysician"
                  >
                    <i class="fa fa-check" aria-hidden="true" v-if="this.DocRecommend" :style="{ ' margin-left': '-7px', 'padding-top': '4px', 'padding-right': ' 6px' }" />
                    {{ this.DocRecommend ? "Recommended" : "Recommend" }}
                  </button>
                </div>
                <div v-else>
                  <button
                    class="font-white primary-button review-btns"
                    :style="{
                      background: viewUser.recommend ? getSecondaryColor() : getPrimaryColor(),
                      cursor: viewUser.recommend ? 'default' : 'pointer',
                      'margin-left': viewUser.isDirectory ? '0px' : '16px',
                      width: viewUser.isDirectory ? '335px' : '159.5px',
                    }"
                    @click="handlereview(viewUser)"
                  >
                    <!-- <i class="fa fa-check" aria-hidden="true" v-if="viewUser.recommend" /> -->
                    Review
                    <!-- {{ viewUser.recommend ? "Reviewed" : "Review" }} -->
                  </button>
                </div>
              </div>

              <a-button
                :loading="loadingbtn"
                class="font-white primary-button mt-3 circle-btn"
                :style="{
                  background: viewUser.on_circle ? getSecondaryColor() : getPrimaryColor(),
                  'pointer-events': viewUser.on_circle ? 'none' : 'all',
                }"
                @click="!viewUser.on_circle && addToCircle()"
              >
                {{ viewUser.on_circle ? "In your circle" : "Add To Circle" }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
      <div class="m-prof-sub">
        <ul class="sub-nav text-center sort-dropdown" :style="{ 'margin-bottom': '0px', display: 'flex' }">
          <li
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="updates"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/updates` ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            Updates
          </li>
          <li
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="about"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/about` ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            About
          </li>
          <li
            v-if="isDirectory && viewUser.role !== 'nfp_administrator'"
            :style="$route.path.includes('receivedreviews') ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="receivedreviews"
            :class="$route.path.includes('receivedreviews') ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            Received Reviews
          </li>
          <!-- <li
            v-if="!isDirectory"
            :style="
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/dovedaily`
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="dovedaily"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/dovedaily` ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            DoveDaily
          </li> -->
          <li
            v-if="!isDirectory"
            id="circles"
            :class="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('self') ||
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/hospitals` ||
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/clinics` ||
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/nfp` ||
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/hcp` ||
              this.$route.path.includes('providers')
                ? 'active-tabs'
                : 'tabs'
            "
            :style="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('self') ||
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/hospitals` ||
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/clinics` ||
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/nfp` ||
              this.$route.path === `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/circles/hcp` ||
              this.$route.path.includes('providers')
                ? {
                    color: getPrimaryColor(),
                    background: getPrimary50Color(),
                  }
                : { color: '#0F1734' }
            "
            @click="handletab($event)"
          >
            Circles
          </li>
          <div
            @click="() => $refs.drawerMenuRef.show()"
            :style="
              this.$route.path.includes('muteduser') ||
              this.$route.path.includes('qa') ||
              this.$route.path.includes('polls') ||
              this.$route.path.includes('saved') ||
              this.$route.path.includes('profilerev') ||
              this.$route.path.includes('medrev') ||
              this.$route.path.includes('receivedreviews') ||
              this.$route.path.includes('profilercmnd') ||
              this.$route.path.includes('treatmentrcmnd')
                ? { color: getPrimaryColor(), background: getPrimary50Color(), 'z-index': 100 }
                : { color: '#0F1734', 'z-index': 100 }
            "
            id="reviews"
            :class="
              this.$route.path.includes('muteduser') ||
              this.$route.path.includes('qa') ||
              this.$route.path.includes('polls') ||
              this.$route.path.includes('saved') ||
              this.$route.path.includes('profilerev') ||
              this.$route.path.includes('medrev') ||
              this.$route.path.includes('receivedreviews') ||
              this.$route.path.includes('profilercmnd') ||
              this.$route.path.includes('treatmentrcmnd')
                ? 'active-tabs'
                : 'tabs'
            "
          >
            <div
              :style="
                this.$route.path.includes('muteduser') ||
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('receivedreviews') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? { color: getPrimaryColor() }
                  : ''
              "
              class="tabe"
            >
              <!-- {{ selectedTab }} -->
              {{ "Reviews & More" }}
              <font-awesome-icon size="1x" :icon="displayDots2M ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
            </div>
          </div>
          <DrawerModal ref="drawerMenuRef">
            <div @click="() => $refs.drawerMenuRef.close()">
              <a-menu-item
                id="qa"
                @click="
                  () => {
                    selectedTab = 'Q&A'
                    $router.push({
                      path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/qa`,
                    })
                  }
                "
                class="drawer-item py-1"
              >
                Q&A
              </a-menu-item>
              <a-menu-item
                id="polls"
                @click="
                  () => {
                    selectedTab = 'Polls'
                    $router.push({
                      path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/polls`,
                    })
                  }
                "
                class="drawer-item py-1"
              >
                Polls
              </a-menu-item>
              <a-menu-item
                id="saved"
                @click="
                  () => {
                    selectedTab = 'Saved'
                    $router.push({
                      path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/saved`,
                    })
                  }
                "
                class="drawer-item py-1"
              >
                Saved
              </a-menu-item>
              <a-menu-item
                id="medrev"
                @click="
                  () => {
                    selectedTab = 'Medication Reviews'
                    $router.push({
                      path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/medrev`,
                    })
                  }
                "
                class="drawer-item py-1"
              >
                Medication Reviews
              </a-menu-item>
              <a-menu-item
                id="treatmentrcmnd"
                @click="
                  () => {
                    selectedTab = 'Treatment Recommendations'
                    $router.push({
                      path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/treatmentrcmnd`,
                    })
                  }
                "
                class="drawer-item py-1"
              >
                Treatment Recommendations
              </a-menu-item>
              <!-- <a-menu-item
                  id="profilercmnd"
                  @click="
                    () => {
                      selectedTab = 'Muted User';
                      $router.push({
                        path: `/${currentCircle.key_name}/profile/view/${
                          viewUser.role
                        }/${viewUser.id || viewUser.ext_ref_id}/muteduser`
                      });
                    }
                  "
                  class="drawer-item"
                >
                  Muted User
                </a-menu-item> -->
              <a-menu-item
                id="receivedreviews"
                @click="
                  () => {
                    selectedTab = 'Received Reviews'
                    $router.push({
                      path: `/${currentCircle.key_name}/profile/view/${viewUser.role}/${viewUser.id || viewUser.ext_ref_id}/receivedreviews/all`,
                    })
                  }
                "
                v-if="viewUser.role !== 'nfp_administrator'"
                class="drawer-item py-1"
              >
                Received Reviews
              </a-menu-item>
            </div>
          </DrawerModal>
        </ul>
      </div>
      <!-- Web view -->
      <div class="dovemed-wrapper m-prof-wrapper py-4 padding-fix">
        <div class="row">
          <div class="col-md-4 col-lg-4 d-prof-progress">
            <div class="d-flex phy-profile-card-container">
              <button class="threedot-menu" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="showOptions">
                <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />
                <div
                  v-if="displayDots"
                  :style="{ display: 'flex', 'flex-direction': 'column', 'align-self': 'flex-end', 'z-index': '1' }"
                  :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`"
                >
                  <p class="card-item" @click="saveToDirectory">
                    <!-- <img src="../../../../assets/images/share.png" :style="{
                    width: '20px',
                    height: '15px',
                    marginRight: '10px'
                  }" alt="share" /> -->
                    <font-awesome-icon :icon="[`${userValues.saved ? 'fas' : 'fal'}`, 'bookmark']" class="mr-2 font20 w20" />{{ userValues.saved ? "Saved to DoveDirectory" : "Save to DoveDirectory" }}
                  </p>
                  <p
                    class="card-item"
                    @click="
                      () => {
                        $refs.ShareProfileModal.showModal()
                      }
                    "
                  >
                    <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                      <path
                        d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                        fill="black"
                      /></svg
                    >Share Profile
                  </p>
                  <p class="divider"></p>
                  <p
                    class="card-item"
                    @click="
                      () => {
                        $refs.reportContentModal.show('', 15)
                      }
                    "
                  >
                    <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 font20" />Report
                  </p>
                  <p class="card-item" @click="muteUser(currentCircle.id, { id: viewUser.id, role: viewUser.role })">
                    <font-awesome-icon :icon="['fal', 'comment-alt-slash']" class="mr-2 w20" />Mute User
                  </p>
                </div>
              </button>
              <div class="profile-image mr-3 position-relative">
                <a-avatar
                  :style="{ color: ' #ffffff !important', 'background-color': viewUser.url ? viewUser.url : '' || viewUser.picture ? viewUser.picture : '' ? '' : '#C997C5' }"
                  :size="150"
                  :src="viewUser.url || viewUser.picture"
                  class="text-capitalize"
                >
                  {{
                    viewUser.display_name
                      ? viewUser.display_name[0]
                      : viewUser.role === "hcp"
                      ? viewUser.hcp_info.full_name[0]
                      : viewUser.doctor_info
                      ? viewUser.doctor_info.full_name[0]
                      : viewUser.nfp_info
                      ? viewUser.nfp_info.nfp_name[0]
                      : "D"
                  }}
                </a-avatar>
              </div>
              <div class="d-flex flex-row" :style="{ 'margin-top': '26px' }">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ 'margin-right': '8px' }">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.6458 0.648784C10.9757 0.238571 11.4736 0 11.9998 0C12.526 0 13.0239 0.238571 13.3537 0.648784L14.9657 2.65518C15.3367 3.11777 15.9179 3.35907 16.5072 3.29518L19.0659 3.01678C19.5905 2.95846 20.1132 3.14192 20.4865 3.51539C20.8598 3.88886 21.0431 4.41184 20.9848 4.93677L20.7066 7.49676C20.6427 8.08643 20.8839 8.66795 21.3462 9.03916L23.3516 10.652C23.7616 10.982 24 11.4801 24 12.0066C24 12.5331 23.7616 13.0312 23.3516 13.3613L21.3398 14.9666C20.8776 15.3384 20.6366 15.9201 20.7002 16.5101L20.9784 19.0701C21.0371 19.5951 20.8539 20.1183 20.4805 20.4919C20.1072 20.8655 19.5842 21.0488 19.0595 20.9901L16.5008 20.7117C15.9115 20.6476 15.3301 20.8889 14.9593 21.3517L13.3537 23.3506C13.0241 23.7612 12.5261 24 11.9998 24C11.4734 24 10.9755 23.7612 10.6458 23.3506L9.03497 21.3453C8.66351 20.8826 8.08199 20.6414 7.49234 20.7053L4.93371 20.9837C4.40886 21.0428 3.88565 20.8596 3.51218 20.4859C3.1387 20.1123 2.95562 19.5888 3.01474 19.0637L3.29299 16.5037C3.35682 15.9137 3.11569 15.3319 2.65333 14.9602L0.649074 13.3485C0.238717 13.0187 0 12.5205 0 11.9938C0 11.4672 0.238717 10.969 0.649074 10.6392L2.65333 9.02636C3.11584 8.65528 3.35705 8.07366 3.29299 7.48396L3.01474 4.92397C2.95604 4.39894 3.13926 3.8757 3.51263 3.50214C3.886 3.12857 4.40896 2.94524 4.93371 3.00398L7.49234 3.28238C8.08196 3.34604 8.66338 3.10482 9.03497 2.64238L10.6458 0.648784Z"
                    fill="#00C853"
                  />
                  <path
                    d="M16.5 9L12.0214 15.3893C11.8746 15.5985 11.6502 15.7293 11.4063 15.7477C11.1624 15.7662 10.923 15.6706 10.7501 15.4856L8.0625 12.6112"
                    stroke="white"
                    stroke-width="2.08333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p :style="{ 'font-weight': '700', 'font-size': '16px', 'line-height': '24px', color: '#00C853' }">Verified and Claimed</p>
              </div>
              <div class="doc-info">
                <p class="m-0 doc-name" v-if="viewUser">
                  <!-- {{
                    viewUser.display_name
                      ? viewUser.display_name + "" + (viewUser.title != null ? "," + viewUser.title : "")
                      : viewUser.role === "hcp"
                      ? viewUser.hcp_info.full_name + "" + (viewUser.title != null ? "," + viewUser.title : "")
                      : viewUser.doctor_info.full_name + "" + (viewUser.title != null ? "," + viewUser.title : "")
                  }} -->
                  {{
                    viewUser.display_name
                      ? viewUser.display_name
                      : viewUser.role === "hcp"
                      ? viewUser.hcp_info.full_name + "" + (viewUser.title != null ? ", " + viewUser.title : "")
                      : viewUser.doctor_info.full_name + "" + (viewUser.title != null ? ", " + viewUser.title : "")
                  }}

                  <!-- {{ viewUser.title !=null ? "," + viewUser.title : "" }} -->
                </p>

                <div class="tag-cont">
                  <div class="physician-tag">
                    <font-awesome-icon v-if="viewUser.role === 'hcp'" class="tag-icon-oran" :icon="['far', 'user-nurse']" :style="{ fill: '#F5A623' }" />
                    <font-awesome-icon v-if="viewUser.role === 'nfp_administrator'" class="tag-icon-oran" :icon="['far', 'hand-holding-heart']" :style="{ fill: '#F5A623' }" />
                    <svg v-if="viewUser.role === 'doctor'" class="tag-icon-oran" :style="{ fill: '#F5A623' }" width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.0835 3.11198C3.0835 1.51693 4.38232 0.195312 6.00016 0.195312C7.59521 0.195312 8.91683 1.51693 8.91683 3.11198C8.91683 4.72982 7.59521 6.02865 6.00016 6.02865C4.38232 6.02865 3.0835 4.72982 3.0835 3.11198ZM7.82308 3.11198C7.82308 2.10938 7.00277 1.28906 6.00016 1.28906C4.97477 1.28906 4.17725 2.10938 4.17725 3.11198C4.17725 4.13737 4.97477 4.9349 6.00016 4.9349C7.00277 4.9349 7.82308 4.13737 7.82308 3.11198ZM4.54183 9.37826C5.06592 9.53776 5.45329 10.0163 5.45329 10.5859C5.45329 11.2923 4.86084 11.862 4.17725 11.862C3.47087 11.862 2.9012 11.2923 2.9012 10.5859C2.9012 10.0163 3.26579 9.53776 3.81266 9.37826V8.44401C2.7417 8.87695 1.98975 9.92513 1.98975 11.1328V11.3151C1.98975 11.6341 1.7391 11.862 1.44287 11.862C1.12386 11.862 0.895996 11.6341 0.895996 11.3151V11.1328C0.895996 8.92253 2.67334 7.1224 4.90641 7.1224H7.09391C9.3042 7.1224 11.1043 8.92253 11.1043 11.1328V11.3151C11.1043 11.6341 10.8537 11.862 10.5575 11.862C10.2384 11.862 10.0106 11.6341 10.0106 11.3151V11.1328C10.0106 9.92513 9.23584 8.87695 8.18766 8.44401V9.37826C8.71175 9.53776 9.09912 10.0163 9.09912 10.5859V11.3151C9.09912 11.5202 8.91683 11.6797 8.73454 11.6797C8.52946 11.6797 8.36995 11.5202 8.36995 11.3151V10.5859C8.36995 10.2897 8.1193 10.0391 7.82308 10.0391C7.50407 10.0391 7.2762 10.2897 7.2762 10.5859V11.3151C7.2762 11.5202 7.09391 11.6797 6.91162 11.6797C6.70654 11.6797 6.54704 11.5202 6.54704 11.3151V10.5859C6.54704 10.0163 6.91162 9.53776 7.4585 9.37826V8.23893C7.32178 8.23893 7.20784 8.21615 7.09391 8.21615H4.90641C4.76969 8.21615 4.65576 8.23893 4.54183 8.23893V9.37826ZM4.17725 11.1328C4.47347 11.1328 4.72412 10.9049 4.72412 10.5859C4.72412 10.2897 4.47347 10.0391 4.17725 10.0391C3.85824 10.0391 3.63037 10.2897 3.63037 10.5859C3.63037 10.9049 3.85824 11.1328 4.17725 11.1328Z"
                      />
                    </svg>
                    <svg
                      v-if="viewUser.role === 'hospital_administrator'"
                      class="tag-icon-oran"
                      :style="{ fill: '#F5A623' }"
                      width="14"
                      height="12"
                      viewBox="0 0 14 12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.53906 9.67448H3.6276C3.4681 9.67448 3.35417 9.8112 3.35417 9.94792V10.8594C3.35417 11.0189 3.4681 11.1328 3.6276 11.1328H4.53906C4.67578 11.1328 4.8125 11.0189 4.8125 10.8594V9.94792C4.8125 9.8112 4.67578 9.67448 4.53906 9.67448ZM7.45573 9.67448H6.54427C6.38477 9.67448 6.27083 9.8112 6.27083 9.94792V10.8594C6.27083 11.0189 6.38477 11.1328 6.54427 11.1328H7.45573C7.59245 11.1328 7.72917 11.0189 7.72917 10.8594V9.94792C7.72917 9.8112 7.59245 9.67448 7.45573 9.67448ZM4.53906 7.48698H3.6276C3.4681 7.48698 3.35417 7.6237 3.35417 7.76042V8.67188C3.35417 8.83138 3.4681 8.94531 3.6276 8.94531H4.53906C4.67578 8.94531 4.8125 8.83138 4.8125 8.67188V7.76042C4.8125 7.6237 4.67578 7.48698 4.53906 7.48698ZM7.45573 7.48698H6.54427C6.38477 7.48698 6.27083 7.6237 6.27083 7.76042V8.67188C6.27083 8.83138 6.38477 8.94531 6.54427 8.94531H7.45573C7.59245 8.94531 7.72917 8.83138 7.72917 8.67188V7.76042C7.72917 7.6237 7.59245 7.48698 7.45573 7.48698ZM10.3724 7.48698H9.46094C9.30143 7.48698 9.1875 7.6237 9.1875 7.76042V8.67188C9.1875 8.83138 9.30143 8.94531 9.46094 8.94531H10.3724C10.5091 8.94531 10.6458 8.83138 10.6458 8.67188V7.76042C10.6458 7.6237 10.5091 7.48698 10.3724 7.48698ZM12.1042 2.38281H11.375V1.67643C11.375 0.85612 10.7142 0.195312 9.91667 0.195312H4.06055C3.26302 0.195312 2.60221 0.85612 2.60221 1.67643V2.38281H1.89583C1.07552 2.38281 0.4375 3.04362 0.4375 3.84115V11.3151C0.4375 11.6341 0.665365 11.862 0.984375 11.862C1.2806 11.862 1.53125 11.6341 1.53125 11.3151V3.84115C1.53125 3.65885 1.69076 3.47656 1.89583 3.47656H3.69596V1.67643C3.69596 1.47135 3.85547 1.28906 4.06055 1.28906H9.91667C10.1217 1.28906 10.2812 1.47135 10.2812 1.67643V3.47656H12.1042C12.2865 3.47656 12.4688 3.65885 12.4688 3.84115V11.3151C12.4688 11.6341 12.6966 11.862 13.0156 11.862C13.3118 11.862 13.5625 11.6341 13.5625 11.3151V3.84115C13.5625 3.04362 12.9017 2.38281 12.1042 2.38281ZM10.3724 9.67448H9.46094C9.30143 9.67448 9.1875 9.8112 9.1875 9.94792V10.8594C9.1875 11.0189 9.30143 11.1328 9.46094 11.1328H10.3724C10.5091 11.1328 10.6458 11.0189 10.6458 10.8594V9.94792C10.6458 9.8112 10.5091 9.67448 10.3724 9.67448ZM8.57227 3.47656H7.72917V2.63346C7.72917 2.49674 7.61523 2.38281 7.47852 2.38281H6.4987C6.36198 2.38281 6.27083 2.49674 6.27083 2.63346V3.47656H5.40495C5.26823 3.47656 5.17708 3.5905 5.17708 3.72721V4.70703C5.17708 4.84375 5.26823 4.9349 5.40495 4.9349H6.27083V5.80078C6.27083 5.9375 6.36198 6.02865 6.4987 6.02865H7.47852C7.61523 6.02865 7.72917 5.9375 7.72917 5.80078V4.9349H8.57227C8.70898 4.9349 8.82292 4.84375 8.82292 4.70703V3.72721C8.82292 3.5905 8.70898 3.47656 8.57227 3.47656Z"
                      />
                    </svg>
                    <svg
                      v-if="viewUser.role === 'clinic_administrator'"
                      class="tag-icon-oran"
                      :style="{ fill: '#F5A623' }"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.45833 4.2513V3.45378C6.45833 3.36263 6.36719 3.27148 6.25325 3.27148H5.56966V2.58789C5.56966 2.47396 5.47852 2.38281 5.38737 2.38281H4.58984C4.4987 2.38281 4.40755 2.47396 4.40755 2.58789V3.27148H3.72396C3.61003 3.27148 3.54167 3.36263 3.54167 3.45378V4.2513C3.54167 4.34245 3.61003 4.43359 3.72396 4.43359H4.40755V5.11719C4.40755 5.23112 4.4987 5.29948 4.58984 5.29948H5.38737C5.47852 5.29948 5.56966 5.23112 5.56966 5.11719V4.43359H6.25325C6.36719 4.43359 6.45833 4.34245 6.45833 4.2513ZM3.9974 6.75781H3.08594C2.92643 6.75781 2.8125 6.89453 2.8125 7.03125V7.94271C2.8125 8.10221 2.92643 8.21615 3.08594 8.21615H3.9974C4.13411 8.21615 4.27083 8.10221 4.27083 7.94271V7.03125C4.27083 6.89453 4.13411 6.75781 3.9974 6.75781ZM3.9974 8.94531H3.08594C2.92643 8.94531 2.8125 9.08203 2.8125 9.21875V10.1302C2.8125 10.2897 2.92643 10.4036 3.08594 10.4036H3.9974C4.13411 10.4036 4.27083 10.2897 4.27083 10.1302V9.21875C4.27083 9.08203 4.13411 8.94531 3.9974 8.94531ZM7.91667 0.195312H2.08333C1.26302 0.195312 0.625 0.85612 0.625 1.65365V11.3151C0.625 11.6341 0.852865 11.862 1.17188 11.862C1.4681 11.862 1.71875 11.6341 1.71875 11.3151V1.65365C1.71875 1.47135 1.87826 1.28906 2.08333 1.28906H7.91667C8.09896 1.28906 8.28125 1.47135 8.28125 1.65365V11.3151C8.28125 11.6341 8.50911 11.862 8.82812 11.862C9.12435 11.862 9.375 11.6341 9.375 11.3151V1.65365C9.375 0.85612 8.71419 0.195312 7.91667 0.195312ZM6.91406 6.75781H6.0026C5.8431 6.75781 5.72917 6.89453 5.72917 7.03125V7.94271C5.72917 8.10221 5.8431 8.21615 6.0026 8.21615H6.91406C7.05078 8.21615 7.1875 8.10221 7.1875 7.94271V7.03125C7.1875 6.89453 7.05078 6.75781 6.91406 6.75781ZM6.91406 8.94531H6.0026C5.8431 8.94531 5.72917 9.08203 5.72917 9.21875V10.1302C5.72917 10.2897 5.8431 10.4036 6.0026 10.4036H6.91406C7.05078 10.4036 7.1875 10.2897 7.1875 10.1302V9.21875C7.1875 9.08203 7.05078 8.94531 6.91406 8.94531Z"
                      />
                    </svg>
                    <div>
                      {{
                        viewUser.role === "doctor"
                          ? "Physician"
                          : viewUser.role === "hospital_administrator"
                          ? "Hospital"
                          : viewUser.role === "clinic_administrator"
                          ? "clinic"
                          : viewUser.role === "nfp_administrator"
                          ? "Non-For-Profit"
                          : viewUser.role === "hcp"
                          ? "Advanced Medical Professional"
                          : viewUser.role
                      }}
                    </div>
                  </div>
                  <div
                    class="tags"
                    :style="{
                      color: getPrimaryColor(),
                      background: getPrimary50Color(),
                    }"
                    v-if="viewUser.speciality"
                  >
                    {{ viewUser.speciality }}
                  </div>
                  <div
                    class="tags"
                    :style="{
                      color: getPrimaryColor(),
                      background: getPrimary50Color(),
                    }"
                    v-if="tag && viewUser.role != 'doctor' && viewUser.role != 'hcp'"
                  >
                    {{ tag }}
                  </div>
                </div>
                <p
                  :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', 'padding-bottom': '14.5px' }"
                  v-if="viewUser.location && viewUser.location[0].city"
                  class="m-0 doc-loc text-truncate"
                >
                  <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
                  {{ viewUser.location[0].street ? viewUser.location[0].street + "," : "" }}
                  {{ viewUser.location[0].city }},
                  {{ viewUser.location[0].state }}
                </p>
                <p
                  :style="{ color: '#0F1734', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', 'padding-bottom': '14.5px' }"
                  v-else-if="userValues.location && userValues.location[0].city"
                  class="m-0 doc-loc text-truncate"
                >
                  <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
                  {{ userValues.location[0].street ? userValues.location[0].street + "," : "" }}
                  {{ userValues.location[0].city }},
                  {{ userValues.location[0].state }}
                </p>
                <p :style="{ 'margin-bottom': '0px' }" v-if="viewUser.role !== 'nfp_administrator'">
                  <ReviewStar :rating="totalRating.toFixed(2)" :key="totalRating" :width="30" :height="30" />
                  <!-- <ReviewStar :rating="userValues.rating ? userValues.rating : viewUser.rating ? viewUser.rating : 0" /> -->
                </p>

                <p
                  :style="{ 'font-weight': '400', 'font-size': '14px', 'line-height': '21px', color: '#0F1734', 'margin-top': '6px !important' }"
                  :key="totalRevCount"
                  v-if="viewUser.role !== 'nfp_administrator'"
                >
                  {{ totalRating.toFixed(2) }}
                  <!-- {{ userValues.rating ? userValues.rating.toFixed(2) : viewUser.rating ? viewUser.rating.toFixed(2) : "0" }} -->
                  stars -
                  {{ totalRevCount }}
                  <!-- {{ userValues.no_of_reviews ? userValues.no_of_reviews : viewUser.review_count ? viewUser.review_count : "0" }} -->
                  reviews
                </p>

                <div class="font14 gray500 mt-3" v-if="viewUser.joined_date">Member since: {{ formatDate(viewUser.joined_date) }}</div>

                <!-- ==========================circle box====================================== -->
                <div class="stat-cont">
                  <div class="statistics">
                    <div class="circle-mem">
                      <span class="num">{{ userValues.no_of_recommendations ? userValues.no_of_recommendations : viewUser.recommendation_count ? viewUser.recommendation_count : 0 }}</span>
                      <span class="num-text">Recommendations</span>
                    </div>
                    <template v-if="viewUser.role !== 'nfp_administrator'">
                      <div class="vertical-seperator"></div>
                      <div class="circle-on">
                        <span class="num">{{ totalRevCount }}</span>
                        <!-- <span class="num">{{ userValues.no_of_reviews ? userValues.no_of_reviews : viewUser.review_count ? viewUser.review_count : 0 }}</span> -->
                        <span class="num-text">Reviews</span>
                      </div>
                    </template>
                  </div>

                  <div class="statistics" v-if="!isDirectory">
                    <div class="circle-mem">
                      <span class="num">{{ userValues.no_of_members ? userValues.no_of_members : viewUser.no_of_members ? viewUser.no_of_members : 0 }}</span>
                      <span class="num-text">Circle Members</span>
                    </div>
                    <div class="vertical-seperator"></div>
                    <div class="circle-on">
                      <span class="num">
                        {{ userValues.no_of_circle_on ? userValues.no_of_circle_on : viewUser.no_of_circle_on ? viewUser.no_of_circle_on : 0 }}
                      </span>
                      <span class="num-text">Circle On</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btns" :style="{ marginTop: '40px' }">
                <div class="d-flex flex-row">
                  <button
                    v-if="!isDirectory"
                    class="font-white primary-button review-btns"
                    :style="{ background: getPrimaryColor(), cursor: 'pointer' }"
                    @click="() => $refs.MessageUserModal.ShowModal(viewUser)"
                  >
                    Message
                  </button>
                  <!-- <div
                    v-if="
                      (viewUser.role === 'nfp_administrator' && (authUser.user.role === 'patient' || authUser.user.role === 'caregiver' || authUser.user.role === 'advocate')) ||
                      ((viewUser.role === 'doctor' || viewUser.role === 'hcp') &&
                        (authUser.user.role === 'hcp' ||
                          authUser.user.role === 'doctor' ||
                          authUser.user.role === 'hospital_administrator' ||
                          authUser.user.role === 'clinic_administrator' ||
                          authUser.user.role === 'nfp_administrator')) ||
                      ((viewUser.role === 'hcp' ||
                        viewUser.role === 'doctor' ||
                        viewUser.role === 'hospital_administrator' ||
                        viewUser.role === 'clinic_administrator' ||
                        viewUser.role === 'nfp_administrator') &&
                        (authUser.user.role === 'doctor' || authUser.user.role === 'hcp'))
                    "
                  > -->
                  <div v-if="!canReview(viewUser.role)">
                    <button
                      class="font-white primary-button review-btns"
                      :style="{
                        background: this.DocRecommend ? getSecondaryColor() : getPrimaryColor(),
                        cursor: this.DocRecommend ? 'default' : 'pointer',
                        'margin-left': viewUser.isDirectory ? '0px' : '16px',
                        display: 'flex',
                        'flex-direction': 'row',
                        width: viewUser.isDirectory ? '335px' : '159.5px',
                      }"
                      :disabled="this.DocRecommend"
                      @click="handleRecomendPhysician"
                    >
                      <i
                        class="fa fa-check"
                        aria-hidden="true"
                        v-if="this.DocRecommend"
                        :style="{
                          ' margin-left': '-7px',
                          'padding-top': '4px',
                          'padding-right': ' 6px',
                        }"
                      />
                      {{ this.DocRecommend ? "Recommended" : "Recommend" }}
                    </button>
                  </div>
                  <div v-else>
                    <button
                      class="font-white primary-button review-btns"
                      :style="{
                        background: viewUser.recommend ? getSecondaryColor() : getPrimaryColor(),
                        cursor: viewUser.recommend ? 'default' : 'pointer',
                        'margin-left': viewUser.isDirectory ? '0px' : '16px',
                        width: viewUser.isDirectory ? '335px' : '159.5px',
                      }"
                      @click="handlereview(viewUser)"
                    >
                      <!-- <i class="fa fa-check" aria-hidden="true" v-if="viewUser.recommend" /> -->
                      Review
                      <!-- {{ viewUser.recommend ? "Reviewed" : "Review" }} -->
                    </button>
                  </div>
                </div>

                <a-button
                  :loading="loadingbtn"
                  class="font-white primary-button mt-3 circle-btn"
                  :style="{
                    background: viewUser.on_circle ? getSecondaryColor() : getPrimaryColor(),
                    'pointer-events': viewUser.on_circle ? 'none' : 'all',
                  }"
                  @click="!viewUser.on_circle && addToCircle()"
                >
                  {{ viewUser.on_circle ? "In your circle" : "Add To Circle" }}
                </a-button>
              </div>
            </div>
          </div>

          <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12 about-phy">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <ReportContentModal ref="reportContentModal" />
    <RecommendDoctorModal ref="RecommendDoctorModal" />
    <RecommendOthersModal ref="recommendOthersModal" />
    <AddToCircle ref="AddToCircle" />
    <ShareProfileModal ref="ShareProfileModal" />
    <MessageUserModal ref="MessageUserModal" />
    <DrawerModal ref="drawerShareRef">
      <div @click="() => $refs.drawerShareRef.close()">
        <p class="drawer-item" @click="saveToDirectory">
          <font-awesome-icon :icon="[`${userValues.saved ? 'fas' : 'fal'}`, 'bookmark']" class="mr-2 font20 w20" />{{ userValues.saved ? "Saved to DoveDirectory" : "Save to DoveDirectory" }}
        </p>
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.ShareProfileModal.showModal()
            }
          "
        >
          <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            /></svg
          >Share Profile
        </p>
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.reportContentModal.show('', 15)
            }
          "
        >
          <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 font20" />Report
        </p>
        <p class="drawer-item" @click="muteUser(currentCircle.id, { id: viewUser.id, role: viewUser.role })"><font-awesome-icon :icon="['fal', 'comment-alt-slash']" class="mr-2 w20" />Mute User</p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import DoctorAbout from "../view/ViewDoctorAbout"
import RecommendOthersModal from "../../../Modals/RecommendOthers"
import DoctorCircles from "../view/ViewDoctorCircles"
import DoctorUpdates from "../view/ViewDoctorUpdates"
import DoctorFav from "../view/ViewDoctorFavorites"
import ViewDoctorProfilePolls from "./ViewDoctorProfilePolls.vue"
import ViewDoctorProfileReviews from "./ViewDoctorProfileReviews.vue"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import RecommendDoctorModal from "../../../Modals/RecommendDoctor"
// import ReviewStar from "../../Doctor/reviewStar.vue"
// import Reviewstarforcircle from "../../Doctor/reviewstarforcircle.vue"
import MessageUserModal from "../../../Modals/MessageUserModal"
import ReportContentModal from "../../../Modals/ReportContent.vue"
import AddToCircle from "../../../Modals/AddToCircle.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons"
import { faBullhorn, faHospital, faHospitalSymbol, faHandHoldingHeart, faHandHeart, faUser, faUserMd, faHospitalAlt, faUserNurse } from "@fortawesome/pro-regular-svg-icons"
import ShareProfileModal from "../../../Modals/ShareProfileModal.vue"
import ReviewStar from "../../../commons/ReviewStar.vue"
import DrawerModal from "../../../Modals/DrawerModal.vue"

library.add(faMapMarkerAlt, faBullhorn, faHandHoldingHeart, faUser, faUserMd, faHospitalAlt, faHospitalSymbol, faUserNurse, faHospital, faHandHeart)
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "DoctorProfile",
  components: {
    DoctorUpdates,
    DoctorAbout,
    DoctorCircles,
    DoctorFav,
    ViewDoctorProfilePolls,
    ViewDoctorProfileReviews,
    RecommendDoctorModal,
    AddToCircle,
    ReviewStar,
    ShareProfileModal,
    MessageUserModal,
    // Reviewstarforcircle,
    RecommendOthersModal,
    ReportContentModal,
    DrawerModal,
  },
  data() {
    return {
      isDirectory: false,
      // defaultImage: null,
      // defaultMaleImage: "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/MALE DOCTOR2x.png",
      // defaultFemaleImage: "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/WOMAN DOCTOR2x.png",
      // apiUrl: "",
      // apiDoc: "https://gist.githubusercontent.com/AbhijitKulkarni95/20a0421d6ad908fae1372c0efad9b4a4/raw/01c32d97571458bb0ca9ef730bb15227e114c69b/doctor_prof.json",
      // apiPat: "https://gist.githubusercontent.com/AbhijitKulkarni95/20a0421d6ad908fae1372c0efad9b4a4/raw/01c32d97571458bb0ca9ef730bb15227e114c69b/patient_prof.json",
      profileData: null,
      cardKeys: null,
      editableData: null,
      loadingbtn: null,
      // toDeleteKeys: ["id", "created_at", "updated_at", "is_deleted", "user", "is_verified", "npi_number", "state_licence", "licence_number"],
      tabs: { updates: true, about: false, circles: false, qa: false, fav: false },
      activeTab: "updates",
      user: null,
      isCircle: false,
      DocRecommend: false,
      displayDots: false,
      displayDots2: false,
      displayDots2M: false,
      displayDots2W: false,
      selectedTab: "Reviews & More",
      no_of_members: 0,
      no_of_circle_on: 0,
      userValues: {},
      tag: "",
      data: null,
      totalRevCount: 0,
      totalRating: 0,
      loading: true,
    }
  },

  created() {
    console.warn("ViewDoctorProfile.vue is created")
    window.addEventListener("mouseup", () => {
      if (this.displayDots) {
        setTimeout(() => {
          this.displayDots = false
        }, 100)
      }
    })
  },

  mounted() {
    this.isDirectory = (this.viewUser && this.viewUser.isDirectory) || this.$route.query.isDirectory ? true : false
    if (Number(this.$route.params.id) === this.authUser.user.id && window.location.href.match(/profile\/view\/([^\/]+)/)[1] === this.authUser.user.role) {
      this.routeToAuthProfile(this.authUser.user.role)
    } else {
      this.fetchDocData().then(() => {
        console.log("this.authUser", this.authUser)
        console.log("this.viewUser", this.viewUser)
        // this.defaultImage = this.getDefaultImage()
        this.DocRecommend = this.viewUser.recommend
        this.loading = false
      })
    }
  },

  computed: {
    getUserName() {
      return this.$store.getters["User/user"].display_name
    },
    ...mapGetters({ toggleReview: "User/toggleReview" }),
  },

  watch: {
    selectedTab: {
      handler() {
        this.displayDots = false
        this.displayDots2 = false
        this.displayDots2M = false
        this.displayDots2W = false
      },
      immediate: true,
    },
    "$route.params.id": {
      handler() {
        this.loading = true
        window.location.reload()
      },
    },
    toggleReview: {
      handler(v) {
        // console.warn("ViewDoctorProfile -> watching toggleReview")
        this.fetchDocData()
      },
    },
    // totalRating(v) {
    //   console.log("totalRating changed to:", v)
    // },
  },

  methods: {
    // getDefaultImage() {
    //   if (this.viewUser.doctor_info) {
    //     return this.viewUser.doctor_info.gender === "m" || this.viewUser.doctor_info.gender === "male" ? this.defaultMaleImage : this.defaultFemaleImage
    //   }
    //   if (this.viewUser.hcp_info) {
    //     return this.viewUser.hcp_info.gender === "m" || this.viewUser.hcp_info.gender === "male" ? this.defaultMaleImage : this.defaultFemaleImage
    //   }
    //   return this.viewUser.gender === "m" || this.viewUser.gender === "male" ? this.defaultMaleImage : this.defaultFemaleImage
    // },
    saveToDirectory() {
      if (this.userValues.saved) {
        return
      }
      let payload = {
        owner_user: this.authUser.user.id,
        owner_user_role: this.authUser.user.role,
        saved_user: this.viewUser.ext_ref_id ? this.viewUser.ext_ref_id : this.viewUser.id,
        saved_user_role: this.viewUser.role,
        circle_id: this.currentCircle.id,
      }
      UserRepository.SaveToDirectory(payload)
        .then(res => {
          this.$notification.success({ message: "Saved", description: `Profile saved to directory successfully` })
          this.userValues.saved = true
        })
        .catch(err => {
          this.$notification.error({ message: "Error", description: `Profile was not saved to directory` })
        })
    },

    handlereview(viewUser) {
      // if (!viewUser.recommend) {
      switch (viewUser.role) {
        case "hcp":
          this.$refs.RecommendDoctorModal.show({
            ...viewUser,
            role: "hcp",
            page: 0,
            inPersonReview: viewUser.in_person_visit,
            onlineReview: viewUser.online_tele_medicine,
            myCirclesReview: viewUser.my_circle,
          })
          break
        case "doctor":
          this.$refs.RecommendDoctorModal.show({
            ...viewUser,
            role: "doctor",
            page: 0,
            inPersonReview: viewUser.in_person_visit,
            onlineReview: viewUser.online_tele_medicine,
            myCirclesReview: viewUser.my_circle,
          })
          break
        case "clinic":
        case "clinic_administrator":
          this.$refs.recommendOthersModal.show({ ...viewUser, role: "clinic", page: 0 })
          break
        case "hospital":
        case "hospital_administrator":
          this.$refs.recommendOthersModal.show({ ...viewUser, role: "hospital", page: 0 })
          break
        case "nfp":
        case "nfp_administrator":
          this.$refs.recommendOthersModal.show({ ...viewUser, role: "nfp_administrator", page: 0 })
          break
      }
      // }
    },

    handleRecomendPhysician() {
      const payload = {
        type: "recommended",
        reviewer_id: this.authUser.user.id,
        reviewer_role: this.authUser.user.role,
        reviewee_id: this.viewUser.ext_ref_id,
        reviewee_role: this.viewUser.role,
        circle_id: this.currentCircle.id,
        recommended: "true",
      }
      // console.log(payload)
      UserRepository.recommendPhysician(payload)
        .then(res => {
          this.$notification.success({ message: "Success", description: "Recommended this physician successfully" })
          this.DocRecommend = true
          this.$store.commit("User/setToggleReview")
          // this.fetchDocData()
          if (this.userValues.no_of_recommendations) {
            this.userValues.no_of_recommendations += 1
          }
          if (this.viewUser.recommendation_count) {
            this.viewUser.recommendation_count += 1
          }
        })
        .catch(err => {
          // console.log("error", err)
        })
    },

    async fetchDocData() {
      const role = window.location.href.match(/profile\/view\/([^\/]+)/)[1]
      try {
        this.loading = true
        if (this.isDirectory) {
          const res = await UserRepository.getOtherEntityProfile({ role: role, ext_ref_id: this.$route.params.id }, this.currentCircle.id)
          this.$store.commit("User/setViewUser", { data: { ...res.data.data, role: role, isDirectory: true } })
          this.DocRecommend = this.viewUser.recommend
          this.userValues = res.data.data
          console.log("1 - this.userValues:", this.userValues)

          const profileType = this.viewUser.role
          switch (profileType) {
            case "hospital_administrator":
              this.tag = this.userValues.hospital_type
              break
            case "clinic_administrator":
              this.tag = this.userValues.clinic_type
              break
            case "nfp_administrator":
              this.tag = this.userValues.nfp_type
              break
            case "hcp":
              this.tag = this.userValues.speciality
              break
            case "doctor":
              this.tag = this.userValues.speciality
              break
          }
        } else {
          const res = await UserRepository.getOtherUserProfileWithId({ role: role, id: this.$route.params.id }, this.currentCircle.id)
          this.$store.commit("User/setViewUser", {
            data: {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              in_person_visit: res.data.data.in_person_visit,
              online_tele_medicine: res.data.data.online_tele_medicine,
              my_circle: res.data.data.my_circle,
              isDirectory: false,
            },
          })
          this.DocRecommend = this.viewUser.recommend
          this.userValues = res.data.data
          console.log("2 - this.userValues:", this.userValues)

          const aboutRes = await UserRepository.getAbout(this.viewUser, this.currentCircle.id)
          this.data = aboutRes.data.data[0]
          const profileType = this.viewUser.role
          switch (profileType) {
            case "hospital_administrator":
              this.tag = this.data.hospital_type
              break
            case "clinic_administrator":
              this.tag = this.data.clinic_type
              break
            case "nfp_administrator":
              this.tag = this.data.nfp_type
              break
            case "hcp":
              this.tag = this.data.speciality
              break
            case "doctor":
              this.tag = this.data.speciality
              break
          }
        }
        if (this.hasCoreReviews(this.viewUser.role)) {
          const headers = { Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`, dtoken: this.authUser.user.dovemed_csrf_token || this.authUser.user.dovemed_session_token }
          // const coreRes = await this.$http.get(`${process.env.SSO_BASE_URL}/api/v2/${this.getCoreReviewApiRole(this.viewUser.role)}/${this.viewUser.ext_ref_id || this.viewUser.id}/review/`, {
          const coreRes = await this.$http.get(`${process.env.SSO_BASE_URL}/api/v2/review/${this.getCoreReviewApiRole(this.viewUser.role)}/${this.viewUser.ext_ref_id || this.viewUser.id}/review/`, {
            headers,
          })
          // console.log("coreRes:", coreRes)

          this.totalRevCount = (this.userValues.no_of_reviews || this.userValues.review_count || this.userValues.reviews_count || 0) + (coreRes.data.count || 0)
          this.totalRating = this.userValues.rating
            ? this.userValues.overall_rating
              ? (this.userValues.rating + this.userValues.overall_rating) / 2
              : this.userValues.rating
            : this.userValues.overall_rating || 0
        }
        this.loading = false
      } catch (e) {
        // this.$notification.error({ message: "Failed", description: "Profile data not fetched" })
        console.log("error:", e)
        console.log("--------------------")
        console.log("error msg:", e.message)
        console.log("--------------------")
        // UserRepository.recordLogout()
        // this.$store.dispatch("Auth/logout").then(() => {
        //   location.reload()
        // })
        this.loading = false
      }
    },

    addToCircle() {
      this.loadingbtn = true
      const data = { ...this.viewUser, ext_ref_id: this.viewUser.id }
      UserRepository.addUserByTypeToCircle(
        this.viewUser.role === "hcp" ? this.viewUser.ext_ref_id : this.viewUser,
        this.currentCircle.id,
        this.viewUser.role === "hcp" ? "other" : this.viewUser.role
      ).then(res => {
        if (this.viewUser.ext_ref_id) {
          UserRepository.getOtherEntityProfile(this.viewUser, this.currentCircle.id)
            .then(res => {
              const data = { role: this.viewUser.role, on_circle: res.data.data.on_circle, ...this.viewUser }
              this.$store.commit("User/setViewUser", { data: data })
              this.viewUser.on_circle = true
              this.loadingbtn = false
              this.isCircle = true
              if (this.viewUser.role === "doctor" || this.viewUser.role === "physician") {
                this.$refs.AddToCircle.show()
              }
              this.fetchDocData()
            })
            .catch(err => {
              this.loadingbtn = false
            })
        } else {
          UserRepository.getOtherUserProfile(this.viewUser, this.currentCircle.id)
            .then(res => {
              // console.log("getOtherUserProfile res.data ==", res.data)
              const data = {
                ...res.data.data.user_info,
                on_circle: res.data.data.on_circle,
                request_to_add: res.data.data.request_to_add,
                recommendations: res.data.data.no_of_recommendations,
                recommend: res.data.data.recommend,
                inPersonReview: res.data.data.in_person_visit,
                onlineReview: res.data.data.online_tele_medicine,
                myCirclesReview: res.data.data.my_circle,
              }
              this.$store.commit("User/setViewUser", { data })
              this.isCircle = true
              this.loadingbtn = false
              if (this.viewUser.role === "doctor" || this.viewUser.role === "physician") {
                this.$refs.AddToCircle.show()
              }
              this.fetchDocData()
            })
            .catch(err => {
              this.loadingbtn = false
            })
        }
      })
    },

    // swapProf() {
    //   this.apiUrl === this.apiDoc ? (this.apiUrl = this.apiPat) : (this.apiUrl = this.apiDoc)
    //   this.fetchDocData(this.apiUrl)
    // },

    // changeTab(e) {
    //   if (this.tabs.hasOwnProperty(e.target.id)) {
    //     this.tabs[this.activeTab] = false
    //     this.tabs[e.target.id] = true
    //     this.activeTab = e.target.id
    //   }
    // },

    handletab(event) {
      this.displayDots = false
      this.displayDots2 = false
      this.displayDots2M = false
      this.displayDots2W = false
      switch (event.target.id) {
        case "updates":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/updates` })
          break
        case "about":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/about` })
          break
        case "receivedreviews":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/receivedreviews/all` })
          break
        case "circles":
          this.selectedTab = "Reviews & More"
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/circles/ViewAllCircle` })
          break
        // case "dovedaily":
        //   this.selectedTab = "Reviews & More"
        //   this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/dovedaily` })
        //   break
        case "qa":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/qa` })
          break
        case "polls":
          this.$router.push({ name: "ViewDoctorProfilePolls" })
          break
        case "saved":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/saved` })
          break
        case "reviews":
          this.$router.push({ name: "ViewDoctorProfileReviews", params: { ext_ref_id: this.viewUser.id, circle_id: this.currentCircle.id } })
          break
        default:
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/updates` })
          break
      }
    },

    showOptions() {
      this.displayDots = !this.displayDots
    },

    // makeKeys(cardKeys) {
    //   let editableKeys = {}
    //   for (var key in cardKeys) {
    //     if (cardKeys.hasOwnProperty(key)) {
    //       editableKeys[cardKeys[key]] = false
    //     }
    //   }
    //   return editableKeys
    // },

    // makeEditable(cardKey) {
    //   this.keys[cardKey] = true
    //   this.editableData = this.data[cardKey]
    // },

    // cancelEditable(cardKey) {
    //   this.keys[cardKey] = false
    //   this.data[cardKey] = this.editableData
    //   this.editableData = null
    // },

    // save(cardKey) {
    //   this.editableData = null
    //   this.keys[cardKey] = false
    // },
  },

  // filters: {
  //   humanize: function(value, capitalize = true) {
  //     if (!value) return ""
  //     return capitalize
  //       ? value
  //           .toLowerCase()
  //           .split("_")
  //           .map(e => e.toUpperCase())
  //           .join(" ")
  //       : value
  //           .toLowerCase()
  //           .split("_")
  //           .map(e => e.charAt(0).toUpperCase() + e.substring(1))
  //           .join(" ")
  //   },

  //   total: function(value, ...options) {
  //     if (!value) return ""
  //     return Array.isArray(value) ? `(${value.length})` : ""
  //   },
  // },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 428px) {
  .m-prof {
    width: 100% !important;
  }
}

.stat-cont {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 48px;
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
}

.num {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.num-text {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.circle-on {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.circle-mem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.statistics {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 8px;
  width: 335px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
  border-radius: 8px;

  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.li {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-decoration: none;
}

.tabe {
  display: flex;
  gap: 5px;
  align-items: center;
}

.review-padding {
  padding-left: 70px;
}

.padding-fix {
  margin-top: 10px;
  padding-top: 0px;
}

@media screen and (max-width: 426px) {
  .review-padding {
    padding-left: 50px !important;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .m-prof-sub ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .m-prof-sub {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
  }

  .m-prof {
    box-shadow: none !important;
    background: none !important;
  }

  .m-prof .circle-card-content {
    margin-top: 0rem !important;
  }
}

.info-phy {
  p {
    margin-bottom: 0px;
  }

  .prof-details-title {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #94a3b8;
  }

  .prof-details-value {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #0f1734;
  }
}

.tag-cont {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 17.5px;
  margin-top: 16px;
}

.about-phy {
  margin-top: 60px;
  margin-left: 420px;
  margin-right: 10px;
}

.prof-details-title {
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.profile-tabs {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  margin-left: 17px;
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px !important;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.review-btns {
  padding: 12px 24px;
  width: 159.5px;
  height: 48px;
  border-radius: 6px;
  border: none;
  justify-content: center;
}

.tag-icon-oran {
  // height: 17.5px;
  // width: 20px;
  color: #f5a623;
  font-size: 12px;
}

.physician-tag {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  background: #fff0d6;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  color: #f5a623;
  text-transform: capitalize;
}

.tags {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  margin-right: 5px;
  border-radius: 4px;
  text-transform: capitalize;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px !important;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.circle-btn {
  padding: 12px 24px;
  width: 335px;
  height: 48px;
  border-radius: 6px;
  border: none;
}

.phy-profile-card-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  height: 937px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: -220px;
}

.banner {
  // min-height: 250px;
  // max-height: 400px;
  height: 400px;

  img {
    min-height: 250px;
    max-height: 400px;
    width: 100%;
    object-fit: cover;
  }
}

.profile-subnav {
  background: #fff;
}

.card-item {
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-left: 0 !important;
  line-height: 32px;
  color: #1e2945;
  display: flex;
  align-items: center;
}

.profile-image {
  min-width: 150px;
  height: 150px;
  align-self: center;
  border-radius: 50%;
}

.mob {
  @media screen and (max-width: 900px) {
    position: relative;
    top: 100px;
    left: 98%;
    z-index: 10;
  }
}

.option-mob {
  @media screen and (max-width: 900px) {
    width: max-content;
  }
}

.doc-info {
  .doc-name {
    font-weight: 700;
    font-size: 36px;
    // line-height: 46px;
    color: #0f1734;
    white-space: inherit;
  }

  .loc {
    margin-bottom: 13px !important;
  }

  .doc-loc text-truncate,
  .recommendations {
    font-size: 16px;
  }
}

ul.sub-nav {
  list-style-type: none;
  padding: 0;

  li {
    display: inline-block;
    margin-right: 20px;
  }
}

.shadow-card {
  .p {
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    color: #1e2945;
  }
}

.nav-sec {
  position: relative;
  width: 66%;
  margin-left: 365px;
  text-align: right;

  .sub-nav {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: #0f1734;
  }
}

.ad-container {
  background: #b6d28a;
  width: 100%;
  height: 400px;
}

.rating-box {
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  padding: 5px 8px;
  display: flex;
  align-items: center;
  color: #fff;
  border-radius: 15px;

  .star-rating {
    margin-right: 5px;
  }

  span {
    color: #fff;
  }
}

@media screen and (max-width: 581px) {
  .doc-info {
    text-align: left;
    margin-top: 10px;
  }

  .about-phy {
    margin-left: 0px;
    margin-top: 0px;
    margin-right: 0px;
  }

  .rating-box {
    position: absolute;
    left: 50%;
    bottom: -16px;
    transform: translateX(-50%);
    padding: 5px 8px;
    display: flex;
    align-items: center;
    color: #fff;
    border-radius: 15px;

    .star-rating {
      margin-right: 5px;
    }

    span {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/view/ViewDoctorProfile.vue